/* eslint-disable react/prefer-stateless-function */
import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { SelectField, MenuItem } from 'material-ui';
import { getSelectedUser, getTimeZones } from './store/action';
import { NitroSingleSelect } from 'nitro-components/build/nitro';

const TimeZoneSelector = ({ timezones, zoneId, setTimeZone }) => {
  const options = timezones.map(x => {
    const gmtOffset = x.gmtOffset / 3600;
    const label = `(GMT ${gmtOffset > 0 ? '+' : '-'} ${gmtOffset}) ${
      x.zoneName
    }`;
    return {
      value: Number(x.zoneId),
      label
    };
  });
  return (
    <NitroSingleSelect options={options} value={zoneId} action={setTimeZone} />
  );
};

export default connect(null, null)(TimeZoneSelector);



// WEBPACK FOOTER //
// ./src/features/userManagement/TimeZoneSelector.js